/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import {
  ReimburseApproveAccount,
  ReimburseRejectAccount,
  viewAccountDetailR,
} from "../../../../../redux/features/accounts/ReimburseAccount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import ICONS from "../../../../../assets/Icons";
import SmallPopupWithInput from "../../../../../components/_utils/CommonSmallPopupWithInput";
import CommonToast from "../../../../../components/_utils/CommonToast";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast";
import { toast } from "react-toastify";

const ReimbursementCategoriesSucess = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const updatedFields = location?.state?.updatedFields || [];
  const { viewAccountDetailData, viewAccountDetailError } = useSelector(
    (state) => state.ReimburseAccount,
  );

  const [isFocused, setIsFocused] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [rejectPopup, setRejectPopup] = useState(false);
  const services = useSelector((state) => state.refreshToken.services);
  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const viewDetailsHandler = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
      {
        replace: true,
      },
    );
  };
  const dashboardHandler = () => {
    navigate("/reimbursement_account_dashboard", {
      replace: true,
    });
  };

  const beneficiaryAccount = viewAccountDetailData?.reimbursement_accounts?.[0];

  const fieldsToShow =
    updatedFields.length > GlobalConfiguration.lengthCheckZero
      ? updatedFields
      : ["category"];

  const fieldConfig = {
    account_name: {
      leftSubTitle: "Account name",
      getTitle: (acc) =>
        acc?.name ? acc?.name?.toLowerCase() : "Not available",
    },
    category: {
      leftSubTitle: "Categories",
      getTitle: (acc) =>
        acc?.category_ids?.map((x) => x?.category_name)?.join(","),
    },
  };

  const renderInfoCards = () => {
    return fieldsToShow
      .filter((key) => fieldConfig[key])
      .map((key) => {
        const config = fieldConfig[key];
        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            rows={[
              {
                leftTitle: config.getTitle(beneficiaryAccount),
                leftSubTitle: config.leftSubTitle,
              },
            ]}
          />
        );
      });
  };

  useEffect(() => {
    if (viewAccountDetailError) {
      navigate("*");
    }
  }, [viewAccountDetailError]);

  useEffect(() => {
    dispatch(viewAccountDetailR({ id }));
  }, [dispatch, id]);

  const approveAcc = async () => {
    try {
      UniversalRefreshToast("Approving account");
      const response = await dispatch(ReimburseApproveAccount(id)).unwrap();

      toast.dismiss();

      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
        {
          replace: true,
        },
      );
      if (response?.status) {
        CommonToast({
          text: "Account approved successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        CommonToast({
          text:
            response?.payload?.errors?.reimbursement_account?.[0] ??
            "Something went wrong.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (err) {
      toast.dismiss();
    }
  };
  const rejectAcc = async ({ id, AccountIdData: accountIdData }) => {
    UniversalRefreshToast("Rejecting account");
    try {
      toast.dismiss();

      const response = await dispatch(
        ReimburseRejectAccount({ id, AccountIdData: accountIdData }),
      );

      navigate(
        `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
        {
          replace: true,
        },
      );
      if (response.payload.status === true) {
        CommonToast({
          text: "Account rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        CommonToast({
          text:
            response?.payload?.errors?.reimbursement_account?.[0] ??
            "Something went wrong.",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    } catch (err) {
      toast.dismiss();
      CommonToast({
        text: "An error occurred while rejecting account.",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      console.error("Rejected failed", err);
    }
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    setDeclineReason(sanitizedValue);
  };

  const buttonRows = [
    ...(services?.includes("RAAccount") || services?.includes("Admin")
      ? [
          [
            {
              btnText: "Reject account",
              enabledBgColor: "var(--negative-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.REJECT_ICON_RED_WITH_WHITE_CIRCLE,
              handleFunction: () => {
                setRejectPopup(true);
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
            {
              btnText: "Approve account",
              enabledBgColor: "var(--positive-act)",
              enabledTextColor: "var(--text-primary)",
              icon: ICONS.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
              handleFunction: () => {
                approveAcc();
              },
              iconToBeAlign: "left",
              fullWidthRequired: true,
            },
          ],
        ]
      : []),
    [
      // {
      //   btnText: "Create account",
      //   enabledBgColor: "var(--text-primary)",
      //   enabledTextColor: "var(--positive-bg)",
      //   icon: ICONS?.CREATE_NEW_ACCOUNT,
      //   handleFunction: () => {
      //     navigate(
      //       `/reimbursement_account_dashboard/create_reimbursement_account`,
      //     );
      //   },
      //   iconToBeAlign: "left",
      //   fullWidthRequired: true,
      //   imgColor: "var(--positive-bg)",
      // },
      // {
      //   btnText: "Create transaction",
      //   enabledBgColor: "var(--text-primary)",
      //   enabledTextColor: "var(--positive-bg)",
      //   icon: ICONS?.ADD_BUTTON_WHITE,
      //   handleFunction: createTxn,
      //   iconToBeAlign: "left",
      //   fullWidthRequired: true,
      //   imgColor: "var(--positive-bg)",
      // },

      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "black",
      },
    ],
  ];

  const AccountIdData = declineReason;
  return (
    <>
      <div>
        {rejectPopup && (
          <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-max-zindex">
            <div className="absolute top-top-base left-top-base h-full w-full opacity-dark-opacity bg-PopUp-BackDrop" />
            <SmallPopupWithInput
              headerTitle="Reject account"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              secondHeaderTitle="Provide the reason for rejection."
              secondHeaderFontWeight="normal"
              secondHeaderFontColor="text-secondary"
              secondHeaderTextSize="font-xs"
              noteColor="text-secondary"
              bulletPoints={[
                "New requests and transactions cannot be created for this account.",
                "Before rejecting this account, reject all associated transactions and requests.",
                "Users can edit the rejected account to update details.",
              ]}
              subtextwithbullet="Y"
              inputPlaceholder={"Reason"}
              inputVariant={computeVariant(declineReason, isFocused)}
              inputOnFocus={(e) => setIsFocused(true)}
              inputOnBlur={(e) => setIsFocused(false)}
              btnOneIsDisabled={showLoader ? true : false}
              inputBgColor="var(--primary-bg)"
              noteText="Minimum 10 characters required."
              inputFgColor="var(--text-secondary)"
              inputOnInput={(e) => {
                if (!showLoader) {
                  handleInputChange(e);
                }
              }}
              inputValue={declineReason}
              inputFontKind="big"
              inputIsFullWidth={true}
              btnOneText="Cancel"
              btnOneHandleFunction={() => {
                setRejectPopup(false);
                setDeclineReason("");
              }}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnTwoText="Reject"
              btnTwoHandleFunction={() => {
                setShowLoader(true);
                rejectAcc({ id, AccountIdData });
              }}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={
                declineReason.trim().length <
                GlobalConfiguration.rejectReasonMinLength
              }
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoHoverOption="black"
              btnTwoInActiveVariantNeeded={true}
            />
          </div>
        )}
        <StatusContainer
          status="success"
          hoverOption="black"
          buttonRows={buttonRows}
          title="Account details updated successfully."
        >
          <TabsWeapperSection title="Updated details">
            <>{renderInfoCards()}</>
          </TabsWeapperSection>
        </StatusContainer>
      </div>
    </>
  );
};

export default ReimbursementCategoriesSucess;
